module.exports = __webpack_public_path__ + "static/Group 468-1009b826e2e812daea4f97bc0e1821d6.png";